import PersistentDataStoreProvider from './persistentDataStoreProvider.js';

const SIDE_BAR_OPEN_CLOSE = 'SIDE_BAR_OPEN_CLOSE';
const REQUESTED_PATH = 'REQUESTED_PATH';
const TC_ACCEPTED = 'TC_ACCEPTED_';

class UserPreferences {
  constructor() {
    this.dataStore = new PersistentDataStoreProvider();
  }

  setSideBarOpenClose(open) {
    this.dataStore.set(SIDE_BAR_OPEN_CLOSE, open);
  }

  getSideBarOpenClose() {
    const val = this.dataStore.get(SIDE_BAR_OPEN_CLOSE);
    return val;
  }

  setRequestedPath(path) {
    this.dataStore.set(REQUESTED_PATH, path);
  }

  getRequestedPath() {
    const val = this.dataStore.get(REQUESTED_PATH);
    return val;
  }

  removeRequestedPath() {
    this.dataStore.remove(REQUESTED_PATH);
  }

  setTcAccepted(userId) {
    this.dataStore.set(TC_ACCEPTED + userId, true);
  }

  getTcAccepted(userId) {
    const val = this.dataStore.get(TC_ACCEPTED + userId);
    return val;
  }
}

export default UserPreferences;
